<template>
  <el-tabs v-model="activeName" @tab-remove="removeTab">
    <el-tab-pane label="待审批" name="list">
      <List ref="list" :addBtn="addBtn" />
    </el-tab-pane>
    <el-tab-pane label="审批记录" name="history">
      <History ref="history" />
    </el-tab-pane>
    <el-tab-pane v-if="billPage" label="审批寻样单" name="bill" closable>
      <Bill ref="bill" :removeTab="removeTab" />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import List from './List';
import History from './History';
import Bill from './Bill';

export default {
  name: 'sample-approval',
  components: {
    List,
    History,
    Bill
  },
  data() {
    return {
      activeName: 'list',
      billPage: false,
    };
  },
  watch: {
    activeName(val) {
      if (val !== 'bill') {
        this.$refs[val].getList();
      }
    },
  },
  methods: {
    removeTab(val, name) {
      this[`${val}Page`] = false;
      this.activeName = name ? name : 'list';
      this.$refs[this.activeName].getList();
    },
    addBtn(val, data) {
      this.activeName = val;
      this[`${val}Page`] = true;
      this.$nextTick(() => {
        this.$refs[val].getListForm(data);
      });
    },
  },
};
</script>
